import { RoleInterface } from "../RoleInterface";
import { Role } from "../Role";
import Translator from "../../../../../Translation/Translator";

class Owner extends Role implements RoleInterface  {

  public static contactRoleId: number = 2;

  public getName(): string {
    return Translator.trans("role-owner");
  }

}

export { Owner };
